<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>mdi-bell</v-icon>
        <span v-if="count" class="badge notifications-count">{{ count }}</span>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, i) in notifications"
        :key="i"
        @click="navigateTo(item.link)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.msg }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="notifications.length == 0">
        <v-list-item-title class="pl-1 pr-1" style="font-size: 80%;">
          <em>{{ $t('notifications.you_have_no_notifications') }}</em>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import navigateMixin from '../../mixins/navigate'

export default {
  mixins: [navigateMixin],

  computed: {
    ...mapState('common', {
      menu: state => state.menu
    }),

    ...mapGetters({
      unreadNetworkingMessagesIds: 'unreadNetworkingMessagesIds',
      unreadMessagesCount: 'unreadMessagesCount',
    }),

    count () {
      return this.unreadNetworkingMessagesIds.length + this.unreadMessagesCount
    },

    notifications () {
      let ntfs = []

      this.checkModule(ntfs, 'networking', this.unreadNetworkingMessagesIds.length, 'notifications.you_have_x_unread_network_messages')
      this.checkModule(ntfs, 'messages', this.unreadMessagesCount, 'notifications.you_have_x_unread_messages')

      return ntfs
    }
  },

  methods: {
    findRoute (moduleName) {
      let routes = this.menu
      for (var i = 0; i < routes.length; i++) {
        if (routes[i].module == moduleName)
          return routes[i]
      }

      return null
    },

    checkModule(notifications, module, count, translateString) {
      let route = this.findRoute(module)
      if (route != null && count > 0) {
        notifications.push({
          title: route.name,
          msg: this.$tc(translateString, count, { n: count }),
          link: {
            slug: route.slug
          }
        })
      }
    },
  }
}
</script>

